module.exports = __webpack_public_path__ + "img/dsci0049.1bf36d5f.jpg";